<template>
  <div class="tableau" v-if="ticket != '-1' && ticket" :style="{ zoom: getZoom }">
    <Tableau :url="url" :width="width" :height="height" ref="meetingTableau">
    </Tableau>
  </div>
  <div v-else-if="ticket == '-1'">
	  <error-section></error-section>
	</div>
  <div v-else>
	</div>
</template>

<script>

import dashboardApi from '@/api/dashboard/index';
import { mapGetters } from 'vuex';
import moment from 'moment';
import Tableau from '../../../common/tableau/Tableau.vue';
import { getZoom } from '../../../../utils';
import global_var from '@/global/global';
import ErrorSection from '../error/ErrorSection.vue';

export default {
  components: { Tableau, ErrorSection },
  data() {
    return {
      ticket: "",
      enterTime: moment().format("YYYY-MM-DD HH:mm:ss"),
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    getZoom,
    url() {
      return `${global_var.DASHBOARD_URL}/trusted/${this.ticket}/${global_var.DASHBOARD_MEETING_URL}?adAccount=${this.userInfo.username}`;
    },
  },
  methods: {
    resizeTableau() {
      // this.tableauWidth = document.getElementsByClassName('tableau')[0].clientWidth;
    },
  },
  mounted() {
    const header = document.querySelector(".header");
    const headerHeight = header.clientHeight;
    const minWidth = 1180;
    const minHeight = 664;
    const maxWidth = 1920;
    const maxHeight = 1080;
    const width = window.screen.width / getZoom();
    const height = window.screen.height / getZoom();
    this.width = width;
    this.height = height;
    dashboardApi.getTableauTicket().then((result) => {
      this.ticket = result;
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeTableau);
    dashboardApi
      .saveStayTime({
        enterTime: this.enterTime,
        leaveTime: moment().format("YYYY-MM-DD HH:mm:ss"),
        description: "仪表盘-会议",
      })
      .then(() => {});
  },
};
</script>

<style lang="less" scoped>
.tableau {
  overflow-x: hidden;
}
</style>


// WEBPACK FOOTER //
// index.vue?580da9f5